let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("is6rK")).then(() => parcelRequire('6Z2Lc'));